export function utilisationState(value: number, target: number, warnAt = 0.9): 'ok' | 'warn' | 'over' {
  const ratio = Math.max(0, value) / target;
  if (ratio > 1) return 'over';
  return ratio >= warnAt ? 'warn' : 'ok';
}
